// 가입 단계 줄 — 계정 → 메일 확인 → 회사 정보 → 규모 → 확인 · 지금 단계는 aria-current.

import { Check } from "lucide-react";

import { cn } from "@/lib/utils";
import { SIGNUP_STEPS } from "@/modules/plan/copy";

export type SignupStep = (typeof SIGNUP_STEPS)[number];

const SignupSteps = ({ current }: { current: SignupStep }) => {
  const at = SIGNUP_STEPS.indexOf(current);
  return (
    <ol aria-label="가입 단계" className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-testid="signup-steps">
      {SIGNUP_STEPS.map((step, i) => (
        <li
          key={step}
          aria-current={i === at ? "step" : undefined}
          className={cn("flex items-center gap-1.5", i === at ? "font-semibold text-foreground" : i < at ? "text-secondary-foreground" : "text-muted-foreground")}>
          <span
            aria-hidden
            className={cn(
              "inline-flex size-5 items-center justify-center rounded-full tabular-nums",
              i < at ? "bg-primary/10 text-primary" : i === at ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"
            )}>
            {i < at ? <Check className="size-3" /> : i + 1}
          </span>
          {step}
        </li>
      ))}
    </ol>
  );
};

export default SignupSteps;
